// extracted by mini-css-extract-plugin
export default {"VideoDimension":"Demonstration_VideoDimension__JG+cB"};